import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import $ from "jquery";
import {FormattedMessage} from "react-intl";
import Analytics from '../../../analytics'

import {setRelatedGroups, setRelatedGroupsSearch} from "../../../actions/selectionFunctions";

// import FeatureInfoDesc from "./featureInfoDesc";
// import FeatureInfoPrice from "./featureInfoPrice";
// import FeatureInfoPriceLocked from "./featureInfoPriceLocked";
import FeatureInfoAssociatedProducts from "./featureInfoAssociatedProducts";
// import FeatureInfoAssociatedFilters from "./featureInfoAssociatedFilters";

class FeatureInfoAssociated extends Component {

  static propTypes = {
    handleFeatureClick: PropTypes.func.isRequired,
  };

  state = {
    addAllClicked: false
  };

  handleAddAllClick = () => {
    Analytics.sendClickEvent('add-all-associated-items');
    this.setState({
      addAllClicked: true
    });

    const scrollTo = document.querySelector(".prod-associated").offsetTop - 110;
    $(".selection-main__info-scrollable").animate({scrollTop: scrollTo}, 800);

    setTimeout(() => {
      const relatedGroups = this.props.relatedGroups.map(relatedGroup => {
        relatedGroup.relatedFeatures.map(relatedFeature => {
          if (!relatedFeature.cartQuantity) {
            relatedFeature.cartQuantity = 1
          }
          return relatedFeature
        });
        return relatedGroup
      });
      this.props.setRelatedGroups(relatedGroups);
    }, 700)
  };

  handleRelatedItemsSearchChange = (event) => {
    this.props.setRelatedGroupsSearch(event.target.value)
  };

  handleViewAllOptionsClick = () => {
    const scrollTo = document.querySelector(".prod-associated").offsetTop;
    $(".selection-main__info-scrollable").animate({scrollTop: scrollTo}, 800);
  };

  render() {

    return (
      <div className="prod">
        {/*<div className="prod-price">*/}
          {/*{this.props.windowWidth < 991 ? (*/}
            {/*<div className="prod-price__block">*/}
              {/*{this.props.showPrice ? (*/}
                {/*<FeatureInfoPrice selectionFeatureInfo={this.props.selectionFeatureInfo}*/}
                                  {/*showDiscount={false}*/}
                                  {/*currencySign={fabricatorSettings.currencySign}*/}
                                  {/*selectionInfoQuantity={this.props.selectionInfoQuantity || 1} />*/}
              {/*) : null}*/}
              {/*{this.props.showPriceLocked ? <FeatureInfoPriceLocked/> : null}*/}
            {/*</div>*/}
          {/*) : null}*/}
        {/*</div>*/}
        {/*<div className="prod-options"></div>*/}
        <div className="prod-top">
          {/*<FeatureInfoAssociatedFilters/>*/}
          <div className="prod-top__search">
            <FormattedMessage id="quotingTool.featureInfo.relatedItems.inputPlaceholder" defaultMessage="Related Item Search">
              {(placeholder) => (
                <input className="ui-input prod-top__search-input"
                       placeholder={placeholder}
                       value={this.props.relatedGroupsSearch}
                       onChange={this.handleRelatedItemsSearchChange}/>
              )}
            </FormattedMessage>
          </div>
          {this.props.windowWidth < 991 ? (
            <div className="prod-top__all">
              <button className="ui-button3 ui-button3--blue" onClick={this.handleViewAllOptionsClick}>
                <FormattedMessage id="quotingTool.featureInfo.relatedItems.viewAlllButton"/>
              </button>
            </div>
          ) : null}
        </div>
        <div className={"prod-all" + (this.state.addAllClicked ? " prod-all--hidden" : "")} ref={(el) => this.prodAll = el}>
          <p className="prod-all__question">
            <FormattedMessage id="quotingTool.featureInfo.relatedItems.addAllItemsQuestion"/>
          </p>
          <button className="ui-button3 ui-button3--white prod-all__button" onClick={this.handleAddAllClick}>
            <FormattedMessage id="quotingTool.featureInfo.relatedItems.addAllItemsButton"/>
          </button>
        </div>
        <FeatureInfoAssociatedProducts handleFeatureClick={this.props.handleFeatureClick} />
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    windowWidth: store.serverState.windowWidth,
    relatedGroups: store.selectionState.relatedGroups,
    relatedGroupsSearch: store.selectionState.relatedGroupsSearch,
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    selectionInfoQuantity: store.selectionState.selectionInfoQuantity,
  };
};

export default connect(mapStateToProps, {
  setRelatedGroups,
  setRelatedGroupsSearch
})(FeatureInfoAssociated);
